/* eslint-disable */
import EDC from "./globals";
import Button from "./button";
import store from "@/store/index";
import router from "@/router/index";

EDC.Preloaders.Summary = function(scene) {
  this.scene = scene;

  // images
  this.scene.load.setPath("https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/summary/");
  this.scene.load.setPrefix("summary-screen-");

  this.scene.load.image("bg", "summary-bg.png");
  this.scene.load.image("diploma", "assignment-summary/Diploma.png");
  this.scene.load.image("assignment-name", "assignment-summary/TitleBubble.png");
  this.scene.load.image("assignment-title", "assignment-summary/Label_Title.png");
  this.scene.load.image("sheets-icon", "assignment-summary/Icon_TestCount.png");
  this.scene.load.image("school-icon", "assignment-summary/Icon_School.png");
  this.scene.load.image("home-icon", "assignment-summary/Icon_Home.png");
  this.scene.load.image("title", "title.png");
  this.scene.load.image("brain-icon", "brain-icon.png");
  this.scene.load.image("plus-icon", "brain-plus.png");
  this.scene.load.image("errors-icon", "accuracy-icon.png");
  this.scene.load.image("time-icon", "time-icon.png");
  this.scene.load.image("value-bg", "value-bg.png");
  this.scene.load.image("ribbon", "ribbon.png");
  this.scene.load.image("star", "star.png");
  this.scene.load.image("star-disabled", "star-disabled.png");
  this.scene.load.image("star-spike", "star-spike.png");
  this.scene.load.image("go-button-normal", "go-button-normal.png");
  this.scene.load.image("go-button-hover", "go-button-hover.png");
  this.scene.load.image("go-button-down", "go-button-down.png");
  this.scene.load.image("history", "assignment-summary/History.png");

  this.scene.load.setPrefix();
  this.scene.load.setPath();

  //audio
  this.scene.load.setPath("https://s3.amazonaws.com/images.growmindgrow/phaser-assets/audio/summary/");
  this.scene.load.setPrefix("summary-audio-");

  this.scene.load.audio("brain", "brain.mp3");
  this.scene.load.audio("star-normal", "star-normal.mp3");
  this.scene.load.audio("star-perfect", "star-perfect.mp3");
  this.scene.load.audio("counting-stats", "counting-stats.mp3");

  this.scene.load.setPrefix();
  this.scene.load.setPath();
};

/**
 * Global Summary screen for all games.
 */
EDC.UI.Summary = function(scene, blurSpriteName, data) {
  this.scene = scene;
  this.blurName = blurSpriteName;
  this.data = data;
  this.summaryTweens = [];
  this.timers = [];
  this.isSkipped = false;

  data.date = new Date().toISOString();
  data.difficulty = scene.difficulty || 1;
  localStorage.setItem("prevGameId", router.currentRoute.params.id);

  var totalCount = this.data.correct + this.data.errors;
  data.accuracyPercents = Math.round((this.data.correct / totalCount) * 100);

  this.container = null;

  this.runDuration = 500;

  this.errorsContainer = null;
  this.errorsIcon = null;
  this.errorsValueBg = null;
  this.errorsValue = null;
  this.currentPercent = 0;
  this.runErrorsDuration = Math.round(this.runDuration / this.data.accuracyPercents);

  this.timeContainer = null;
  this.timeIcon = null;
  this.timeValueBg = null;
  this.timeValue = null;
  this.maxSeconds = this.data.time % 60;
  this.maxMinutes = Math.floor(this.data.time / 60);
  this.runMinutesDuration = Math.round(this.runDuration / this.maxMinutes);
  this.runSecondsDuration = Math.round(this.runDuration / this.maxSeconds);
  this.currentSeconds = 0;
  this.currentMinutes = 0;

  this.brainContainer = null;
  this.brainIcon = null;
  this.brainPointsText = null;
  this.brainPointsValue = 0;
  this.currentBrainPoint = 0;
  this.diplomaContainer = null;
  this.diplomaIcon = null;
  this.assignmentNameContainer = null;
  this.teacherIconContainer = null;
  this.teacherValue = null;
  this.schoolIcon = null;
  this.sheetsIconContainer = null;
  this.sheetsIcon = null;
  this.iconsCoordinate = {};
  this.isAssignment = false;

  this.bg = null;
  this.titleText = null;
  this.blurBg = null;

  this.starsContainer = null;
  this.stars = [];
};
/**
 *
 */
EDC.UI.Summary.prototype.create = function({ actualAssignment, nextGame, assignmentReport }) {
  this.isAssignment = assignmentReport;
  this.assignmentReport = assignmentReport;
  this.assignment = actualAssignment;
  this.blurBg = this.scene.add.sprite(0, 0, this.blurName).setOrigin(0);
  this.blurBg.setAlpha(0);
  this.container = this.scene.add.container(this.scene.game.config.width / 2, this.scene.game.config.height / 2);
  this.bg = this.scene.add.sprite(0, 0, "summary-screen-bg");
  this.container.add(this.bg);

  this.iconsCoordinate = this.isAssignment
    ? {
        numberOfGames: {
          x: this.bg.x + 30,
          y: this.bg.y + 50
        },
        teacher: {
          x: this.bg.x - 270,
          y: this.bg.y + 40
        },
        errors: {
          x: this.bg.x + 180,
          y: this.bg.y + 150
        },
        time: {
          x: this.bg.x - 90,
          y: this.bg.y + 150
        }
      }
    : {
        errors: {
          x: this.bg.x,
          y: this.bg.y + 60
        },
        time: {
          x: this.bg.x + 20,
          y: this.bg.y + 170
        }
      };

  const title = this.isAssignment ? "summary-screen-assignment-title" : "summary-screen-title";
  this.titleText = this.scene.add.sprite(this.bg.x, this.bg.y - this.bg.height / 2 + 125, title);
  this.container.add(this.titleText);

  var ribbon = this.scene.add.sprite(this.bg.x, this.bg.y + this.bg.height / 2 - 90, "summary-screen-ribbon");
  this.container.add(ribbon);

  let goButton = new Button(this.scene, ribbon.x, ribbon.y + 20).create(
    "summary-screen-go-button-normal",
    "summary-screen-go-button-hover",
    "summary-screen-go-button-down"
  );
  const buttonContainer = goButton.getContainer();
  this.scene.tweens.add({
    targets: buttonContainer,
    scaleX: 1.1,
    scaleY: 1.1,
    ease: "Sine.easeInOut",
    duration: 1000,
    yoyo: true,
    repeat: -1
  });
  this.container.add(buttonContainer);
  goButton.setClickCallback(() => {
    this.scene.time.delayedCall(1000, this.buttonClicked, [], this);
  });

  this.createErrors();
  this.container.add(this.errorsContainer);

  this.createTime();
  this.container.add(this.timeContainer);

  if (!this.isAssignment) {
    this.createBrain();
    this.container.add(this.brainContainer);
  } else {
    this.createDiploma();
    this.container.add(this.diplomaContainer);

    this.createAssignmentName();
    this.container.add(this.assignmentNameContainer);

    this.createTeacherIcon();
    this.container.add(this.teacherIconContainer);

    this.createSheetsIcon();
    this.container.add(this.sheetsIconContainer);

    const historyIcon = this.scene.add.sprite(0, 285, "summary-screen-history").setScale(0.8);
    this.container.add(historyIcon);
  }

  this.createStars();
  this.container.add(this.starsContainer);

  this.container.setScale(0, 0);
};
EDC.UI.Summary.prototype.buttonClicked = function() {
  const isALI = localStorage.getItem("ALI");
  if (document.referrer.indexOf(process.env.VUE_APP_PARENT_GAME_LIST) !== -1) {
    window.location.replace(document.referrer);
  } else if (isALI) {
    router.push({ name: "games-continue" });
  } else if (this.assignment && nextGame) {
    store.dispatch("gameConfig/reRenderGame");
    router.push({
      name: "game",
      params: { id: nextGame.id },
      query: { assignment: this.assignment._id }
    });
  } else {
    router.push({ name: "next-game" });
  }
  this.scene.game.destroy(true);
};

/**
 *
 */
EDC.UI.Summary.prototype.createStars = function() {
  this.starsContainer = this.scene.add.container(0, -215);
  const spikePoint = new Phaser.Geom.Point(0, 0);
  var starPoints = [
    new Phaser.Geom.Point(spikePoint.x - 100, spikePoint.y + 25),
    new Phaser.Geom.Point(spikePoint.x, spikePoint.y - 12),
    new Phaser.Geom.Point(spikePoint.x + 100, spikePoint.y + 25)
  ];

  this.starSpike = this.scene.add.sprite(spikePoint.x, spikePoint.y, "summary-screen-star-spike");
  this.starSpike.setAlpha(0);
  this.starsContainer.add(this.starSpike);

  for (var i = 0; i < starPoints.length; i++) {
    var point = starPoints[i];
    var starEmpty = this.scene.add.sprite(point.x, point.y, "summary-screen-star-disabled");
    starEmpty.setAlpha(0.2);
    this.starsContainer.add(starEmpty);

    var starFull = this.scene.add.sprite(point.x, point.y, "summary-screen-star");
    starFull.setScale(0, 0);
    this.starsContainer.add(starFull);
    this.stars.push(starFull);
  }
};
/**
 *
 */
EDC.UI.Summary.prototype.createBrain = function() {
  this.brainContainer = this.scene.add.container(this.bg.x, this.bg.y - 60);
  this.brainIcon = this.scene.add.sprite(0, 0, "summary-screen-brain-icon");
  this.brainContainer.add(this.brainIcon);

  var plusIcon = this.scene.add.sprite(0, 0, "summary-screen-plus-icon");
  plusIcon.setPosition((this.brainIcon.width - plusIcon.width) / 2, (this.brainIcon.height - plusIcon.height) / 2);
  this.brainContainer.add(plusIcon);

  this.brainPointsText = this.scene.add.text(plusIcon.x + plusIcon.width / 2, plusIcon.y, this.brainPointsValue, {
    fontFamily: "Arial",
    fontSize: "60px",
    fill: "#eb008b",
    fontStyle: "bold"
  });
  this.brainPointsText.setOrigin(0, 0.5);
  this.brainPointsText.setAlpha(0);
  this.brainContainer.add(this.brainPointsText);
};
/**
 *
 */
EDC.UI.Summary.prototype.createErrors = function() {
  var originX = this.iconsCoordinate.errors.x;
  var originY = this.iconsCoordinate.errors.y;
  this.errorsContainer = this.scene.add.container(originX, originY);
  this.errorsContainer.setData("originY", originY);
  this.errorsIcon = this.scene.add.sprite(0, 0, "summary-screen-errors-icon").setOrigin(-0.2, 0);
  this.errorsIcon.setScale(0.85);
  this.errorsValueBg = this.scene.add
    .sprite(
      this.errorsIcon.x + this.errorsIcon.width * 0.85,
      this.errorsIcon.y + this.errorsIcon.height / 2,
      "summary-screen-value-bg"
    )
    .setOrigin(0);
  this.errorsValueBg.y -= this.errorsValueBg.height / 2;

  this.errorsContainer.add(this.errorsValueBg);
  this.errorsContainer.add(this.errorsIcon);
  this.errorsContainer.setAlpha(0);
  let bounds = this.errorsContainer.getBounds();
  this.errorsContainer.setData("originX", originX - bounds.width + this.errorsValueBg.width / 2);
};
/**
 *
 */
EDC.UI.Summary.prototype.createTime = function() {
  var originX = this.iconsCoordinate.time.x;
  var originY = this.iconsCoordinate.time.y;
  this.timeContainer = this.scene.add.container(originX, originY);
  this.timeContainer.setData("originY", originY);
  this.timeIcon = this.scene.add.sprite(0, 0, "summary-screen-time-icon").setOrigin(0);
  this.timeValueBg = this.scene.add
    .sprite(
      this.timeIcon.x + this.timeIcon.width * 0.9,
      this.timeIcon.y + this.timeIcon.height / 2 + 5,
      "summary-screen-value-bg"
    )
    .setOrigin(0);
  this.timeValueBg.y -= this.timeValueBg.height / 2;

  this.timeContainer.add(this.timeValueBg);
  this.timeContainer.add(this.timeIcon);
  this.timeContainer.setAlpha(0);
  let bounds = this.timeContainer.getBounds();
  this.timeContainer.setData("originX", originX - bounds.width + this.timeValueBg.width / 2);
};
/**
 * Assignment Summary Elements
 */
EDC.UI.Summary.prototype.createDiploma = function() {
  this.diplomaContainer = this.scene.add.container(this.bg.x, this.bg.y - 60);
  this.diplomaIcon = this.scene.add.sprite(0, -60, "summary-screen-diploma");
  this.diplomaContainer.add(this.diplomaIcon);
};
/**
 *
 */
EDC.UI.Summary.prototype.createAssignmentName = function() {
  this.assignmentNameContainer = this.scene.add.container(this.bg.x, -10);
  const assignmentNameBg = this.scene.add.sprite(0, 0, "summary-screen-assignment-name");
  const assignmentName =
    this.assignment.playlists[0].assignment_name || this.assignment.playlists[0].default_assignment_name;
  const assignmentNameValue = this.scene.add
    .text(0, 0, assignmentName, {
      fontFamily: "Arial",
      fontSize: "46px",
      fill: "#000000"
    })
    .setOrigin(0.5);
  this.assignmentNameContainer.add(assignmentNameBg);
  this.assignmentNameContainer.add(assignmentNameValue);
};
/**
 *
 */
EDC.UI.Summary.prototype.createTeacherIcon = function() {
  var originX = this.iconsCoordinate.teacher.x;
  var originY = this.iconsCoordinate.teacher.y;
  this.teacherIconContainer = this.scene.add.container(originX, originY);
  this.teacherIconContainer.setData("originY", originY);
  this.schoolIcon = this.scene.add.sprite(0, 0, "summary-screen-school-icon").setOrigin(-0.2, 0);
  this.schoolIcon.setScale(0.85);
  this.teacherValueBg = this.scene.add
    .sprite(
      this.schoolIcon.x + this.schoolIcon.width * 0.9,
      this.schoolIcon.y + this.schoolIcon.height / 2 + 5,
      "summary-screen-value-bg"
    )
    .setOrigin(0);
  this.teacherValueBg.y -= this.teacherValueBg.height / 2;

  this.teacherIconContainer.add(this.teacherValueBg);
  this.teacherIconContainer.add(this.schoolIcon);
  this.teacherIconContainer.setAlpha(0);
  let bounds = this.teacherIconContainer.getBounds();
  this.teacherIconContainer.setData("originX", originX - bounds.width + this.teacherValueBg.width / 2);
};
/**
 *
 */
EDC.UI.Summary.prototype.createSheetsIcon = function() {
  var originX = this.iconsCoordinate.numberOfGames.x;
  var originY = this.iconsCoordinate.numberOfGames.y;
  this.sheetsIconContainer = this.scene.add.container(originX, originY);
  this.sheetsIconContainer.setData("originY", originY);
  this.sheetsIcon = this.scene.add.sprite(0, 0, "summary-screen-sheets-icon").setOrigin(-0.2, 0);
  this.sheetsValueBg = this.scene.add
    .sprite(
      this.sheetsIcon.x + this.sheetsIcon.width * 0.9,
      this.sheetsIcon.y + this.sheetsIcon.height / 2 + 5,
      "summary-screen-value-bg"
    )
    .setOrigin(0);
  this.sheetsValueBg.y -= this.sheetsValueBg.height / 2;

  this.sheetsIconContainer.add(this.sheetsValueBg);
  this.sheetsIconContainer.add(this.sheetsIcon);
  this.sheetsIconContainer.setAlpha(0);
  let bounds = this.sheetsIconContainer.getBounds();
  this.sheetsIconContainer.setData("originX", originX - bounds.width + this.sheetsValueBg.width / 2);
};
/**
 * Assignment Summary Elements
 */
EDC.UI.Summary.prototype.getTimeValueString = function() {
  let result = 0;
  if (this.isAssignment) {
    const times = this.assignmentReport.logs.map(item => item.logs.time);
    const secondsSum = times.reduce((sum, time) => (sum += time), 0);
    let minutes = Math.floor(secondsSum / 60);
    let seconds = secondsSum - minutes * 60;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    result = minutes + ":" + seconds;
  } else {
    var secondsStr = this.currentSeconds < 10 ? "0" + this.currentSeconds : this.currentSeconds;
    var minutesStr = this.currentMinutes < 10 ? "0" + this.currentMinutes : this.currentMinutes;
    result = minutesStr + ":" + secondsStr;
  }

  return result;
};
/**
 *
 */
EDC.UI.Summary.prototype.show = function() {
  this.scene.tweens.add({
    targets: this.blurBg,
    alpha: 1,
    duration: 500,
    ease: "Linear",
    onComplete: this.showPopup.bind(this)
  });
};
/**
 *
 */
EDC.UI.Summary.prototype.showPopup = function() {
  this.scene.tweens.add({
    targets: this.container,
    scaleX: 1,
    scaleY: 1,
    duration: 1000,
    ease: "Bounce.easeOut",
    onComplete: this.showElements.bind(this)
  });
};
/**
 *
 */
EDC.UI.Summary.prototype.showElements = function() {
  this.scene.sound.stopAll();
  this.scene.input.on("pointerup", this.skipAnimations.bind(this), this);
  const timer1 = this.scene.time.addEvent({
    delay: 4000,
    callback: this.showStars,
    callbackScope: this
  });
  this.timers.push(timer1);
  if (this.isAssignment) {
    this.showTeacherIcon();
    this.showSheetsIcon();
  } else {
    const timer2 = this.scene.time.addEvent({
      delay: 2000,
      callback: this.showBrainPoints,
      callbackScope: this
    });
    this.timers.push(timer2);
  }
  this.showTimeIcon();
  this.showErrorsIcon();
};

EDC.UI.Summary.prototype.skipAnimations = function() {
  this.scene.sound.stopAll();
  this.isSkipped = true;
  this.timers.map(timer => {
    timer.remove();
  });
  this.summaryTweens.map(tween => {
    tween.stop();
  });
  //  time
  this.currentSeconds = this.maxSeconds;
  this.currentMinutes = this.maxMinutes;
  this.timeValue.setText(this.getTimeValueString());

  //  accuracy
  this.currentPercent = this.data.accuracyPercents;
  this.errorsValue.setText(this.currentPercent + "%");

  //  brain points
  this.brainPointsText.setAlpha(1);
  this.brainPointsText.setText(15);

  //  stars
  const ranges = EDC.Settings.StarsPercentsRange;
  let starsCount = 3;
  for (var i = 0; i < ranges.length; i++) {
    if (this.data.accuracyPercents >= ranges[i]) {
      break;
    }
    starsCount--;
  }
  for (let i = 0; i < starsCount; i++) {
    this.stars[i].setScale(1, 1);
  }
  if (starsCount == 3) {
    this.starSpike.setAlpha(1);
    this.scene.sound.add("summary-audio-star-perfect").play();
  } else {
    this.starSpike.setAlpha(0);
    this.scene.sound.add("summary-audio-star-normal").play();
  }
};
/**
 *
 */
EDC.UI.Summary.prototype.showTime = function() {
  //NOTE: if need more quicker counter - need to use setTimeout, because embeded timer is relative with engine FPS
  if (!this.isSkipped) {
    this.scene.sound.play("summary-audio-counting-stats");
    const timer1 = this.scene.time.addEvent({
      delay: this.runMinutesDuration,
      callback: this.incrementMinutes,
      callbackScope: this,
      repeat: this.maxMinutes
    });
    const timer2 = this.scene.time.addEvent({
      delay: this.runSecondsDuration,
      callback: this.incrementSeconds,
      callbackScope: this,
      repeat: this.maxSeconds
    });
    this.timers.push(timer1);
    this.timers.push(timer2);
  }
};
/**
 *
 */
EDC.UI.Summary.prototype.showErrors = function() {
  //NOTE: if need more quicker counter - need to use setTimeout, because embeded timer is relative with engine FPS
  if (!this.isSkipped) {
    const timer = this.scene.time.addEvent({
      delay: this.runErrorsDuration,
      callback: this.incrementErrors,
      callbackScope: this,
      repeat: this.data.accuracyPercents
    });
    this.timers.push(timer);
  }
};
/**
 *
 */
EDC.UI.Summary.prototype.showErrorsIcon = function() {
  this.errorsContainer.x -= 600;
  const errors = this.isAssignment ? this.getTotalAssignmentErrors() : this.currentPercent;
  const tween = this.scene.tweens.add({
    targets: this.errorsContainer,
    x: this.errorsContainer.getData("originX"),
    alpha: 1,
    duration: 250,
    ease: "Sine.easeIn",
    onComplete: function() {
      this.errorsValue = this.scene.add
        .text(
          this.errorsValueBg.x + this.errorsValueBg.width / 2,
          this.errorsValueBg.y + this.errorsValueBg.height / 2,
          errors + "%",
          {
            fontFamily: "Arial",
            fontSize: "50px",
            fill: "#000000"
          }
        )
        .setOrigin(0.5);
      this.errorsContainer.add(this.errorsValue);
      setTimeout(this.showErrors.bind(this), 250);
    }.bind(this)
  });
  this.summaryTweens.push(tween);
};
/**
 *
 */
EDC.UI.Summary.prototype.showTimeIcon = function() {
  this.timeContainer.x += 600;
  const timeIcon = this.scene.tweens.add({
    targets: this.timeContainer,
    x: this.timeContainer.getData("originX"),
    alpha: 1,
    duration: 250,
    ease: "Sine.easeIn",
    onComplete: function() {
      this.timeValue = this.scene.add
        .text(
          this.timeValueBg.x + this.timeValueBg.width / 2,
          this.timeValueBg.y + this.timeValueBg.height / 2,
          this.getTimeValueString(),
          {
            fontFamily: "Arial",
            fontSize: "50px",
            fill: "#000000"
          }
        )
        .setOrigin(0.5);
      this.timeContainer.add(this.timeValue);
      setTimeout(this.showTime.bind(this), 250);
    }.bind(this)
  });
  this.summaryTweens.push(timeIcon);
};
/**
 *
 */
EDC.UI.Summary.prototype.showTeacherIcon = function() {
  this.teacherIconContainer.x += 600;
  this.scene.tweens.add({
    targets: this.teacherIconContainer,
    x: this.iconsCoordinate.teacher.x,
    alpha: 1,
    duration: 250,
    ease: "Sine.easeIn",
    onComplete: function() {
      this.teacherValue = this.scene.add
        .text(
          this.teacherValueBg.x + this.teacherValueBg.width / 2,
          this.teacherValueBg.y + this.teacherValueBg.height / 2,
          "Parent",
          {
            fontFamily: "Arial",
            fontSize: "46px",
            fill: "#000000"
          }
        )
        .setOrigin(0.5);
      this.teacherIconContainer.add(this.teacherValue);
    }.bind(this)
  });
};
/**
 *
 */
EDC.UI.Summary.prototype.showSheetsIcon = function() {
  this.sheetsIconContainer.x -= 600;
  this.scene.tweens.add({
    targets: this.sheetsIconContainer,
    x: this.iconsCoordinate.numberOfGames.x,
    alpha: 1,
    duration: 250,
    ease: "Sine.easeIn",
    onComplete: function() {
      this.numberOfGames = this.scene.add
        .text(
          this.sheetsValueBg.x + this.sheetsValueBg.width / 2,
          this.sheetsValueBg.y + this.sheetsValueBg.height / 2,
          this.assignmentReport.logs.length,
          {
            fontFamily: "Arial",
            fontSize: "46px",
            fill: "#000000"
          }
        )
        .setOrigin(0.5);
      this.sheetsIconContainer.add(this.numberOfGames);
    }.bind(this)
  });
};
/**
 *
 */
EDC.UI.Summary.prototype.getTotalAssignmentErrors = function() {
  let result = 0;
  const setOfScores = this.assignmentReport.logs.map(item => item.logs.accuracyPercents);
  const scoresSum = setOfScores.reduce((sum, score) => (sum += score), 0);
  result = scoresSum / this.assignmentReport.logs.length;
  return result;
};
/**
 *
 */
EDC.UI.Summary.prototype.incrementMinutes = function() {
  this.currentMinutes++;
  if (this.currentMinutes <= this.maxMinutes) {
    this.timeValue.setText(this.getTimeValueString());
  }
};
/**
 *
 */
EDC.UI.Summary.prototype.incrementSeconds = function() {
  this.currentSeconds++;
  if (this.currentSeconds <= this.maxSeconds) {
    this.timeValue.setText(this.getTimeValueString());
  }
};
/**
 *
 */
EDC.UI.Summary.prototype.incrementErrors = function() {
  this.currentPercent++;
  if (this.currentPercent <= this.data.accuracyPercents) {
    this.errorsValue.setText(this.currentPercent + "%");
  }
};
/**
 *
 */
EDC.UI.Summary.prototype.showBrainPoints = function() {
  this.brainPointsValue = 15;
  this.currentBrainPoint = 0;
  this.brainPointsText.setText(this.currentBrainPoint);
  this.incrementBrainPoint();
};
/**
 *
 */
EDC.UI.Summary.prototype.incrementBrainPoint = function() {
  if (!this.isSkipped) {
    this.currentBrainPoint++;
    if (this.currentBrainPoint <= this.brainPointsValue) {
      const music = this.scene.sound.add("summary-audio-brain");
      music.play();
      music.setSeek(0.3);
      this.brainPointsText.setText(this.currentBrainPoint);
      this.brainPointsText.setAlpha(0.98);
      const tween = this.scene.tweens.add({
        targets: this.brainPointsText,
        ease: "Linear",
        duration: 50,
        alpha: 1,
        onComplete: () => {
          this.incrementBrainPoint();
        }
      });
      this.summaryTweens.push(tween);
    }
  }
};
/**
 *
 */
EDC.UI.Summary.prototype.showStars = function() {
  var ranges = EDC.Settings.StarsPercentsRange;
  var starsCount = 3;
  for (var i = 0; i < ranges.length; i++) {
    if (this.data.accuracyPercents >= ranges[i]) {
      break;
    }
    starsCount--;
  }
  if (starsCount < 0) {
    starsCount = 0;
  }
  var delay = 450;

  if (starsCount > 0) {
    for (var i = 0; i < starsCount; i++) {
      this.stars[i].setScale(0, 0);
      this.showStar(i, this.stars[i], delay * i);
    }
  }
};
/**
 *
 */
EDC.UI.Summary.prototype.showStar = function(index, starSprite, delay) {
  const music =
    index == 2 ? this.scene.sound.add("summary-audio-star-perfect") : this.scene.sound.add("summary-audio-star-normal");
  music.play({ delay: delay / 1000 });
  const tween = this.scene.tweens.add({
    targets: starSprite,
    scaleX: 1,
    scaleY: 1,
    duration: 500,
    delay: delay,
    ease: "Back",
    easeParams: [8],
    onComplete: function(index) {
      if (index === 2) {
        this.scene.tweens.add({
          targets: this.starSpike,
          alpha: 1,
          duration: 120
        });
      }
    }.bind(this, index)
  });
  this.summaryTweens.push(tween);
};

let exportPreloader = EDC.Preloaders.Summary;
let exportSummary = EDC.UI.Summary;

export { exportPreloader as SummaryPreloader, exportSummary as Summary };
